<template>
    <div class="about content">
        <div class="bread">
            <bread :data="[{path: '/about', title: '关于我们'}]"></bread>
        </div>

        <card class="types">
            
            <tab-btn
                :data="types"
                v-model="type"
                
            ></tab-btn>
        </card>

        <card class="main-con">
            <div 
                v-if="type === 'about'" 
                class="company"
                v-html="richPreHandler(detail.infocontent)"
            ></div>

            <div
                class="lxwm"
                v-if="type !== 'about'">
                    <h2 style="text-align:center;font-size:26px;font-weight:600">联系我们</h2>
                    <div class="left">
                        <ul>
                            <li>
                                <p>单位名称：</p>
                                <p>河北信德建设发展集团有限公司</p>
                            </li>
                            <li>
                                <p>单位地址：</p>
                                <p>河北省邢台市信都区太行路1290号4层401室</p>
                            </li>
                            <!-- <li>
                                <p>邮政编码：</p>
                                <p>050011</p>
                            </li> -->
                            <li>
                                <p>廉政电话：</p>
                                <p>0311-80902221</p>
                            </li>
                            <li>
                                <p>邮箱：</p>
                                <p>hb@zhbykj.com</p>
                            </li>
                            <li>
                                <p>客服电话：</p>
                                <p>400-780-9998</p>
                            </li>
                        </ul>
                    </div>
                    <div class="right">
                        <img src="/images/map.png"/>

                    </div>
            </div>

        </card>
    </div>
</template>

<script>
import CONFIG from '@config/index';
import Card from '@components/sys/card';
import List from '@components/sys/list';
import Bread from '@components/sys/bread';
import TabBtn from '@components/sys/tab-btn';

export default {
    components: {
        Card,
        List,
        Bread,
        TabBtn,
    },
    data: () => ({
        tableData: [],

        type: 'about',

        types: [
            {
                label: '公司介绍',
                value: 'about'
            },
            {
                label: '联系我们',
                value: 'download'
            },
        ],

        detail: {},

        center: { lng: 114.511182, lat: 38.048421 },
        zoom: 18, //缩放级别
        scroll: true, //地图缩放
        dragging: true, //地图拖拽

    }),
    methods: {
        queryAbout() {
            this.$get(`${this.$store.state.api.webUrl}/index/information/getwebinfounion.json`, {
                maxrow:1,
                featurecode:CONFIG.head.planName,
                categoryids:'105'
            }, data => {
                if(data){
                    this.detail = data;
                }
            });
        },
        richPreHandler(html) {
            if (!html) return '';

            var res = html;

            res = res.replace(/&nbsp;/g, '');

            return res;
        },
      
    },
    mounted() {
        this.queryAbout();
    },
}
</script>


<style lang="scss" scoped>
@import '@css/var.scss';

.about{
    margin-bottom: 26px;

    .types{
        margin-bottom: 12px;

        .type-sel{
            overflow: hidden;

            .item{
                float: left;
                font-size: 16px;
                line-height: 1em;
                padding: 8px 10px;
                border-radius: 18px;
                border: 1px solid #d6d6d6;
                cursor: pointer;

                & + .item{
                    margin-left: 1em;
                }

                &.active{
                    color: white;
                    background: $primaryColor;
                    border-color: $primaryColor;
                }
            }
        }
    }

    .main-con{
        min-height: 400px;
        padding: 30px;
        width: 100%;
    }

    // .company{
    //     padding: 30px;
    //     background: url(/images/about.png) no-repeat;
    //     background-size: cover;
    // }

    .lxwm{
        overflow: hidden;
        padding: 20px;
        h2{
            margin-bottom: 20px;
        }
        .left{
            float: left;
            ul{
                margin-top: 10px;
            }
            li{
                font-size: 16px;
                line-height: 32px;
                margin-bottom: 20px;
            }
        }
        .right{
            float: right;
            margin-top: 40px;
            img{
                width:750px
            }
            .bdwindow{
                width: 750px;
                height: 500px;
            }

        }
    }
}
</style>
